export default "{\n    \"comingSoonText\": \"Coming Soon\"\n}\n"